const mediaItems = [
  {
    title: '独家探秘：2026暑期档最受期待影视剧大盘点',
    desc: '从古装仙侠到都市情感，暑期档热门作品全面前瞻，哪些值得追看？',
    image: 'https://readdy.ai/api/search-image?query=Professional%20studio%20shot%20of%20film%20clapperboard%20and%20cinema%20equipment%20on%20warm%20neutral%20background%20cinematic%20atmosphere%20soft%20lighting%20clean%20aesthetic%20editorial%20photography&width=400&height=280&seq=media-card-01&orientation=landscape',
    tag: '影视',
  },
  {
    title: '深度解读：上半年娱乐圈十大热搜事件回顾',
    desc: '那些刷爆全网的娱乐圈名场面，背后的故事与真相一一揭开。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20microphone%20on%20stage%20with%20dramatic%20warm%20lighting%20entertainment%20industry%20vibe%20concert%20performance%20atmosphere%20professional%20photography%20soft%20bokeh%20background&width=400&height=280&seq=media-card-02&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '幕后花絮：热门综艺录制现场一手直击',
    desc: '走进综艺背后的世界，那些镜头之外的惊喜与感动。',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20studio%20set%20with%20cameras%20and%20lighting%20equipment%20warm%20ambient%20lighting%20professional%20broadcast%20environment%20clean%20composition%20editorial%20style&width=400&height=280&seq=media-card-03&orientation=landscape',
    tag: '综艺',
  },
  {
    title: '明星专访精选：那些你不知道的台前幕后故事',
    desc: '多位当红艺人倾情分享演艺道路上的心路历程与独家幕后。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20entrance%20with%20velvet%20ropes%20and%20golden%20stanchions%20warm%20glamorous%20lighting%20celebrity%20event%20atmosphere%20sophisticated%20editorial%20photography&width=400&height=280&seq=media-card-04&orientation=landscape',
    tag: '专访',
  },
  {
    title: '吃瓜快报：本周娱乐圈最新动向速览',
    desc: '一网打尽本周最热话题，从新剧开机到恋情曝光，速览不迷路。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20news%20studio%20desk%20with%20digital%20screens%20displaying%20entertainment%20headlines%20warm%20professional%20lighting%20clean%20contemporary%20aesthetic%20broadcast%20journalism%20style&width=400&height=280&seq=media-card-05&orientation=landscape',
    tag: '快报',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              媒体聚焦
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              精选娱乐圈最值得关注的深度内容与独家报道
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {mediaItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
              >
                <div className="relative aspect-[4/3] bg-background-200 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className="ri-play-fill text-xl ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-medium text-foreground-800 leading-snug mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}